import { render, staticRenderFns } from "./VikiCoachCard.vue?vue&type=template&id=17a54e10&scoped=true&"
import script from "./VikiCoachCard.vue?vue&type=script&lang=js&"
export * from "./VikiCoachCard.vue?vue&type=script&lang=js&"
import style0 from "./VikiCoachCard.vue?vue&type=style&index=0&id=17a54e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a54e10",
  null
  
)

export default component.exports